import { z } from 'zod';

const monthValue = z.string().regex(/^\d{4}-\d{2}$/, 'Mês inválido');

export const PlanningFormSchema = z.object({
	method: z.enum(['irrigation', 'broad'], { error: 'Método de aplicação é obrigatório' }),
	startMonth: monthValue,
	endMonth: monthValue,
	packId: z.string(),
});

export const createPlanningSchema = (planMonths: string[]) =>
	PlanningFormSchema.superRefine((data, ctx) => {
		if (data.startMonth > data.endMonth) {
			ctx.addIssue({
				code: 'custom',
				path: ['endMonth'],
				message: 'Mês final deve ser igual ou posterior ao mês inicial',
			});
		}

		if (!planMonths.includes(data.startMonth)) {
			ctx.addIssue({
				code: 'custom',
				path: ['startMonth'],
				message: 'Mês inicial não está no plano de adubação',
			});
		}

		if (!planMonths.includes(data.endMonth)) {
			ctx.addIssue({
				code: 'custom',
				path: ['endMonth'],
				message: 'Mês final não está no plano de adubação',
			});
		}

		if (data.method === 'irrigation' && !data.packId) {
			ctx.addIssue({
				code: 'custom',
				path: ['packId'],
				message: 'Pacote de produtos é obrigatório',
			});
		}
	});

export type PlanningSchemaType = z.infer<typeof PlanningFormSchema>;
